<div ng-controller="fieldFilterConfigController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>